import styles from "./index.module.css";
import PopupModal from "../../../Components/PopupModal";
import Input from "../../../Components/FormComponents/Input";
import FakeButton from "../../../Components/FormComponents/FakeButton";
import { useContext, useState } from "react";
import UserContext from "../../../store/UserStore/context";
import { useNavigate } from "react-router-dom";
import { isTestUserEmail, startTestUserSession } from "../../../testUser";
import { apiUrl } from "../../../config";

export default function BookPopup({ close }) {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const userStore = useContext(UserContext);
  return (
    <PopupModal
      close={close}
      contentClassName={styles.modalContent}
      closeClassName={styles.close}
      closeIconHeight="20px"
    >
      <div className={styles.container}>
        <h2 className={styles.title}>Записатись на інтенсив</h2>
        <div className={styles.desc}>
          Наступним кроком буде проходження
          <br />
          тесту для визначення твого рівня мови
        </div>
        <Input
          onChange={(e) => {
            setEmail(e);
          }}
          value={email}
          type={"email"}
          className={styles.input}
          placeholder="example@email.com"
          label={"Введи свій е-mail"}
        />
        <div className={styles.actions}>
          <FakeButton
            disabled={!email}
            className={styles.button}
            onClick={async () => {
              // Shared test account — never reaches the backend, see src/testUser.js
              if (isTestUserEmail(email)) {
                const testUser = startTestUserSession();
                userStore.actions.setUser(testUser);
                navigate(testUser.isPaid ? "/successful-payment" : "/payment");
                return;
              }
              const res = await fetch(
                apiUrl(`/api/intensive/user?email=${email}`),
              );
              if (res.ok) {
                const data = await res.json();
                userStore.actions.setUser(data);
                // Even an already-paid user is sent back to the payment page —
                // repeat payments are allowed, so isPaid no longer skips it.
                navigate(
                  data?.testResult && Number.isInteger(data?.testResult)
                    ? "/payment"
                    : data?.isPaid
                      ? "/successful-payment"
                      : "/test",
                );
              } else {
                if (res.status === 404) {
                  const postres = await fetch(
                    apiUrl(`/api/intensive/user?email=${email}`),
                    {
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                      },
                      credentials: "include",
                      method: "post",
                      body: JSON.stringify({
                        email,
                      }),
                    },
                  );
                  if (postres.ok) {
                    const data = await postres.json();
                    userStore.actions.setUser(data);

                    navigate("/test");
                  }
                }
              }
            }}
            red
          >
            Продовжити
          </FakeButton>
          <div className={styles.privacy}>
            Натискаючи «Продовжити», ти приймаєш{" "}
            <a href={"/contract-offer"} target={"_blank"} rel="noreferrer">
              угоду
            </a>
          </div>
        </div>
      </div>
    </PopupModal>
  );
}
